import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { HomeComponent } from './pages/home/home.component';
import { StartComponent } from './pages/start/start.component';
import { AuthComponent } from './pages/auth/auth.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { EndComponent } from './pages/end/end.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: StartComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'q',
    component: HomeComponent,
    data: {
      title: 'Question'
    }
  },
  {
    path: 'profile/:id',
    component: ProfileComponent,
    data: {
      title: 'Profile'
    }
  },
  {
    path: 'e',
    component: EndComponent,
    data: {
      title: 'Ending'
    }
  },
  {
    path: 'auth',
    component: AuthComponent,
    data: {
      title: 'Account'
    }
  },
  {
    path: 'error',
    component: PageNotFoundComponent,
    data: {
      title: 'Page not Found',
      customLayout: false
    }
  },
  { path: '**', redirectTo: '/error' }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
